export default "__VITE_ASSET__24b6ea79__"